import { render } from "./DisplayStatType.vue?vue&type=template&id=86d3896a"
import script from "./js/displayStatType.js?vue&type=script&lang=js&external"
export * from "./js/displayStatType.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__